import { styles } from "./styles";
import GazableButton from "components/GazableButton/GazableButton";
import gazableButtons from "constants/gazableButtons";
import homeIcon from "../../static/home.svg";
import { Link } from "react-router-dom";
import { routes } from "routes";
import { useCanvasStore } from "store/CanvasStore";

const GoHome = () => {
  const { resetGame } = useCanvasStore();
  return (
    <Link to={routes.home}>
      <GazableButton
        type={gazableButtons.squareButtonThree}
        content=""
        style={styles.returnHomeBtn}
        onClick={resetGame}
      >
        <img src={homeIcon} alt="Home Screen" width="50" height="50" />
      </GazableButton>
    </Link>
  );
};

export default GoHome;
